<div [ngClass]="styleClass" (click)="onClick()">
  <fa-icon class="icon" [icon]="'exclamation-circle'"></fa-icon>
  <h5>
    <ng-content>

    </ng-content>
  </h5>
</div>
